import { api } from '../../../api/common/instances';

const state = {
  mainrec: {},
  loadingCount: 0,
};

const mutations = {
  setMainrec(state, data) {
    state.mainrec = data;
  },
  increaseLoadingCount(state) {
    state.loadingCount++;
  },
  resetLoadingCount(state) {
    state.loadingCount = 0;
  },
};

const actions = {
  async fetchMainrec({ commit }, step) {
    const { data: data } = await api.get('/analysis/ssrviewer/detail/mainrec', {
      params: {
        bgnYmdhms: step.bgnYmdhms,
        sstmId: step.sstmId,
        instId: step.instId,
        seq: step.seq,
        account: step.account,
        terminalid: step.terminalid,
      },
    });
    commit('setMainrec', data);
  },
  increaseLoadingCount({ commit }) {
    commit('increaseLoadingCount');
  },
  resetLoadingCount({ commit }) {
    commit('resetLoadingCount');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
